import { Component, OnInit } from '@angular/core';
import { PathologyPrintService } from '../pathology-print.service';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-print-pathology-form',
    templateUrl: './print-pathology-form.component.html',
    styleUrls: ['./print-pathology-form.component.scss'],
    standalone: false
})
export class PrintPathologyFormComponent implements OnInit {
  examId
  now:Date;
  exam
  load=false

  constructor(public print:PathologyPrintService,private route: ActivatedRoute,public translate: TranslateService) { 
    this.now=new Date();
  }

  ngOnInit(): void {
    this.translate.use('he-IL');
    this.examId = this.route.snapshot.params.examId;
    this.print.loadExam(this.examId)
    this.print.loadMsg.subscribe(()=>{
      
    })
  }

 
}
